import { render, staticRenderFns } from "./PraticheFilter.vue?vue&type=template&id=48a1de4a&"
import script from "./PraticheFilter.vue?vue&type=script&lang=js&"
export * from "./PraticheFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a1de4a')) {
      api.createRecord('48a1de4a', component.options)
    } else {
      api.reload('48a1de4a', component.options)
    }
    module.hot.accept("./PraticheFilter.vue?vue&type=template&id=48a1de4a&", function () {
      api.rerender('48a1de4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ShipmentsPage/PraticheFilter.vue"
export default component.exports